module.exports = __webpack_public_path__ + "static/media/3@3x.a6ca1401.png";